import { mobile } from '../../../utils/breakpoints'
import { styled } from '@mui/material'
import { HEADER_BANNER_HEIGHT } from '../../../theme'

import { ImageSkeleton } from '../../Skeleton/ImageSkeleton'
export const StyledHeaderBanner = styled('img')`
  width: 100%;
  max-height: ${HEADER_BANNER_HEIGHT.desktop};
  object-fit: cover;
  ${({ theme }) => mobile(theme, { 'max-height': HEADER_BANNER_HEIGHT.mobile })}
`

export const BannerSkeleton = styled(ImageSkeleton)`
  width: 100%;
  height: ${HEADER_BANNER_HEIGHT.desktop};
  ${({ theme }) => mobile(theme, { height: HEADER_BANNER_HEIGHT.mobile })}
`
